import logo from './logos/ambulo-logo-512x512-cherry-white.svg'

export default logo ;